import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlertIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 35,
	height: 43,
	viewBox: "0 0 35 43",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 19.3306,
			cy: 6.5,
			rx: 2.68999,
			ry: 2.5,
			fill: "#E0DEF1"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 23.891,
			cy: 29.5,
			rx: 3.76599,
			ry: 3.5,
			fill: "#E0DEF1"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 19.1252,
			cy: 19,
			rx: 12.0783,
			ry: 12,
			fill: "#E0DEF1"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 32.4693,
			cy: 36.5,
			rx: 2.53176,
			ry: 2.5,
			fill: "#BCA4FF"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 29.9346,
			cy: 42,
			rx: 1.0127,
			ry: 1,
			fill: "#F0EEFF"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 24.8721,
			cy: 1,
			rx: 1.0127,
			ry: 1,
			fill: "#BCA4FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.1003 29.8346C21.0976 29.8346 26.0044 24.9596 26.0044 19.0013C26.0044 13.043 21.0976 8.16797 15.1003 8.16797C9.10311 8.16797 4.19629 13.043 4.19629 19.0013C4.19629 24.9596 9.10311 29.8346 15.1003 29.8346Z",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.1006 14.668V20.0846",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.0947 23.332H15.1045",
			stroke: "#7548F0",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgAlertIcon;
